import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Features from '../components/Features';
import HowItWorks from '../components/HowItWorks';
import ProjectsSection from '../components/ProjectsSection';
import DownloadSection from '../components/DownloadSection';
import Footer from '../components/Footer';

const BulkLeadsCaller = () => {
  return (
    <>
      <Header />
      <Hero />
      <Features />
      <HowItWorks />
      <ProjectsSection />
      <DownloadSection />
      <Footer />
    </>
  );
};

export default BulkLeadsCaller;
